<h6  style="font-size: initial;">
    You logged in as <span style="color: lightcoral;">{{loginAsEmail}}</span>
</h6>

